import React from 'react';
import Skeleton from 'components/ui/Skeleton/Skeleton';
import ProductCardSkeleton from 'components/ui/ProductCard/ProductCardSkeleton';

export const CatalogSkeleton = ({ variant = 'catalog' }) => {
  const isSearch = variant === 'search';

  return (
    <div className={`catalog-skeleton catalog-skeleton--${variant}`} aria-hidden="true">
      <div className="catalog-skeleton__container">
        {!isSearch && (
          <Skeleton width="min(260px, 70%)" height="20px" className="catalog-skeleton__breadcrumb" />
        )}

        {isSearch ? (
          <div className="catalog-skeleton__search-heading">
            <Skeleton width="min(360px, 70%)" height="32px" />
            <Skeleton width="180px" height="14px" />
          </div>
        ) : (
          <div className="catalog-skeleton__banner">
            <Skeleton width="100%" height="100%" />
          </div>
        )}

        <div className="catalog-skeleton__layout">
          <aside className="catalog-skeleton__sidebar">
            <Skeleton width="45%" height="12px" />
            <div className="catalog-skeleton__filters">
              {[1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="catalog-skeleton__filter-row">
                  <Skeleton width="24px" height="24px" variant="circle" />
                  <Skeleton width="60%" height="14px" />
                </div>
              ))}
            </div>
          </aside>

          <main className="catalog-skeleton__products">
            {!isSearch && (
              <div className="catalog-skeleton__controls">
                <Skeleton width="100%" height="70px" className="catalog-skeleton__subcategories" />
                <Skeleton width="100%" height="64px" className="catalog-skeleton__toolbar" />
              </div>
            )}

            <div className="catalog-skeleton__grid">
              {Array.from({ length: 12 }).map((_, index) => (
                <ProductCardSkeleton key={`catalog-sk-${index}`} />
              ))}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default CatalogSkeleton;
